import type { ComponentChildren } from 'preact'
import { Steps } from '@/components'
import { Button } from '../ui/Button'
import { LegalNotice } from '../LegalNotice'
import { Divider } from '../ui/Divider'

interface MainContentLayoutProps {
  title: string
  currentStep: number
  totalSteps: number
  children: ComponentChildren
  ctaButtonText?: string
  ctaButtonOnClick?: () => void
  ctaButtonDisabled?: boolean
  showCTA?: boolean
  showLegalNotice?: boolean
  showDivider?: boolean
  className?: string
}

export function MainContentLayout({
  title,
  currentStep,
  totalSteps,
  children,
  ctaButtonText,
  ctaButtonOnClick,
  ctaButtonDisabled = false,
  showCTA = true,
  showLegalNotice = false,
  showDivider = false,
  className = '',
}: MainContentLayoutProps) {
  return (
    <div className={`${className}`}>
      <div className='sm:flex sm:justify-between sm:items-center mb-4 mt-4'>
        <div className='flex justify-end mb-2 sm:hidden'>
          <Steps current={currentStep} total={totalSteps} />
        </div>
        <h2 className='text-heading-3 sm:text-heading-2 text-gray-900'>
          {title}
        </h2>
        <div className='hidden sm:block'>
          <Steps current={currentStep} total={totalSteps} />
        </div>
      </div>

      {showDivider && <Divider className='my-6' />}

      <div className='mb-6'>{children}</div>

      {showCTA && ctaButtonText && ctaButtonOnClick && (
        <div className='flex justify-center mt-6 mb-4'>
          <Button
            type='primary'
            size='lg'
            className='rounded-3xl tracking-[0.4px]'
            onClick={ctaButtonOnClick}
            disabled={ctaButtonDisabled}
          >
            {ctaButtonText}
          </Button>
        </div>
      )}

      {showLegalNotice && (
        <div className='mt-6'>
          <LegalNotice />
        </div>
      )}
    </div>
  )
}
